export const CONTAINS = 'Contains';
export const DOES_NOT_EQUAL = 'DoesNotEqual';
export const EQUALS = 'Equals';
export const END_RANGE = 'EndRange';
export const GREATER_THAN = 'GreaterThan';
export const GREATER_THAN_OR_EQUAL = 'GreaterThanOrEqualTo';
export const IS_BETWEEN = 'IsBetween';
export const IS_NOT_SET = 'IsNotSet';
export const IS_SET = 'IsSet';
export const LESS_THAN = 'LessThan';
export const LESS_THAN_OR_EQUAL = 'LessThanOrEqualTo';
export const MATCHES_REGEX = 'MatchesRegex';
export const STARTS_WITH = 'StartsWith';
export const START_RANGE = 'StartRange';
export const WITHIN = 'LessThan';
export const IS_ONE_OF = 'IsOneOf';
export const IS_NOT_ONE_OF = 'IsNotOneOf';

export const comparators = {
  [CONTAINS]: CONTAINS,
  [DOES_NOT_EQUAL]: DOES_NOT_EQUAL,
  [EQUALS]: EQUALS,
  [END_RANGE]: END_RANGE,
  [GREATER_THAN]: GREATER_THAN,
  [GREATER_THAN_OR_EQUAL]: GREATER_THAN_OR_EQUAL,
  [IS_BETWEEN]: IS_BETWEEN,
  [IS_NOT_SET]: IS_NOT_SET,
  [IS_SET]: IS_SET,
  [LESS_THAN]: LESS_THAN,
  [LESS_THAN_OR_EQUAL]: LESS_THAN_OR_EQUAL,
  [MATCHES_REGEX]: MATCHES_REGEX,
  [STARTS_WITH]: STARTS_WITH,
  [START_RANGE]: START_RANGE,
  [WITHIN]: WITHIN,
  [IS_ONE_OF]: IS_ONE_OF,
  [IS_NOT_ONE_OF]: IS_NOT_ONE_OF,
};

export const CONTAINS_SYMBOL = '⊃';
export const DOES_NOT_EQUAL_SYMBOL = '≠';
export const EQUALS_SYMBOL = '=';
export const END_RANGE_SYMBOL = '⇥';
export const GREATER_THAN_SYMBOL = '>';
export const GREATER_THAN_OR_EQUAL_SYMBOL = '>=';
export const IS_BETWEEN_SYMBOL = '↔';
export const IS_NOT_SET_SYMBOL = '∄';
export const IS_SET_SYMBOL = '∃';
export const LESS_THAN_SYMBOL = '<';
export const LESS_THAN_OR_EQUAL_SYMBOL = '<=';
export const MATCHES_REGEX_SYMBOL = '.*';
export const STARTS_WITH_SYMBOL = '⊳';
export const START_RANGE_SYMBOL = '⇤';
export const WITHIN_SYMBOL = '↔';
// TODO: update based on design
export const IS_ONE_OF_SYMBOL = '=';
export const IS_NOT_ONE_OF_SYMBOL = '≠';

const comparatorConfigs = {
  CONTAINS: { name: CONTAINS, symbol: CONTAINS_SYMBOL },
  DOES_NOT_EQUAL: { name: DOES_NOT_EQUAL, symbol: DOES_NOT_EQUAL_SYMBOL },
  EQUALS: { name: EQUALS, symbol: EQUALS_SYMBOL },
  END_RANGE: { name: END_RANGE, symbol: END_RANGE_SYMBOL },
  GREATER_THAN: { name: GREATER_THAN, symbol: GREATER_THAN_SYMBOL },
  GREATER_THAN_OR_EQUAL: { name: GREATER_THAN_OR_EQUAL, symbol: GREATER_THAN_OR_EQUAL_SYMBOL },
  IS_BETWEEN: { name: IS_BETWEEN, symbol: IS_BETWEEN_SYMBOL },
  IS_NOT_SET: { name: IS_NOT_SET, symbol: IS_NOT_SET_SYMBOL },
  IS_SET: { name: IS_SET, symbol: IS_SET_SYMBOL },
  LESS_THAN: { name: LESS_THAN, symbol: LESS_THAN_SYMBOL },
  LESS_THAN_OR_EQUAL: { name: LESS_THAN_OR_EQUAL, symbol: LESS_THAN_OR_EQUAL_SYMBOL },
  MATCHES_REGEX: { name: MATCHES_REGEX, symbol: MATCHES_REGEX_SYMBOL },
  STARTS_WITH: { name: STARTS_WITH, symbol: STARTS_WITH_SYMBOL },
  START_RANGE: { name: START_RANGE, symbol: START_RANGE_SYMBOL },
  WITHIN: { name: WITHIN, symbol: WITHIN_SYMBOL },
  IS_ONE_OF: { name: IS_ONE_OF, symbol: IS_ONE_OF_SYMBOL },
  IS_NOT_ONE_OF: { name: IS_NOT_ONE_OF, symbol: IS_NOT_ONE_OF_SYMBOL },
};

export default comparatorConfigs;
